<!-- 进度条 -->
<template>
  <div>
    <div>
      <eui-steps :active="isActive-1" :data="processData"></eui-steps>
    </div>
<!--    <div class="process-wrap">-->
<!--      <div class="process-item" v-for="(item, index) in processData" :key="index">-->
<!--        <div class="top">-->
<!--          <i class="arrow-right-white" v-if="index > 0"></i>-->
<!--          <i class="line line-left" :class="[index < isActive ? 'active' : '']"></i>-->
<!--          <span class="num-circle" :class="[index < isActive ? 'active' : '']">-->
<!--            {{ index + 1 }}-->
<!--          </span>-->
<!--          <i class="line line-right" :class="[index < isActive ? 'active' : '']"></i>-->
<!--          <i class="arrow-right" :class="[index < isActive ? 'active' : '']"></i>-->
<!--        </div>-->
<!--        <div class="bottom">-->
<!--          <ul>-->
<!--            <li :class="[index < isActive ? 'active' : '']">{{ item.itemName }}</li>-->
<!--          </ul>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  props: {
    processData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isActive: {
      type: [Number, String],
      default: () => {
        return 1;
      },
    },
  },
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.process-wrap {
  display: flex;
  // margin: 40px 25px;
  text-align: center;
}
.process-item {
  width: 240px;
  .top {
    font-size: 0;
    display: flex;
    // justify-content: center;
    align-items: center;
    width: 240px;
    .num-circle {
      display: inline-block;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      border-radius: 50%;
      background: #d9d9d9;
      font-size: 14px;
      color: #fff;
      flex-shrink: 0;
      &.active {
        background: #2587ff;
      }
    }
    .line {
      display: inline-block;
      width: 100%;
      height: 4px;
      background: #d9d9d9;
      &.active {
        background: #2587ff;
      }
    }
  }
  .bottom {
    width: 100%;
    // height: 134px;
    overflow-y: auto;
    margin-top: 10px;
    ul {
      li {
        line-height: 1;
        color: #333;
        font-size: 14px;
        margin-bottom: 10px;
        &.active {
          color: #2587ff;
        }
      }
    }
  }
}
/* 向右的箭头 */

.arrow-right {
  display: inline-block;
  font-size: 0;
  line-height: 0;
  border-width: 2px;
  border-color: #d9d9d9;
  border-right-width: 0;
  border-style: dashed;
  border-left-style: solid;
  border-top-color: transparent;
  border-bottom-color: transparent;
  &.active {
    // border-color:#2587FF;
    display: inline-block;
    font-size: 0;
    line-height: 0;
    border-width: 2px;
    border-color: #2587ff;
    border-right-width: 0;
    border-style: dashed;
    border-left-style: solid;
    border-top-color: transparent;
    border-bottom-color: transparent;
  }
}
.arrow-right-white {
  display: inline-block;
  font-size: 0;
  line-height: 0;
  border-width: 2px;
  border-color: #fff;
  border-right-width: 0;
  border-style: dashed;
  border-left-style: solid;
  /* margin-right: 7px; */
  border-top-color: transparent;
  border-bottom-color: transparent;
  position: absolute;
}
</style>
